import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { GradientStarIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { getFromLocalStorage, getPlatform } from 'modules/global';
import { useBuyPremium } from 'modules/pro/hooks';

import Merchants from './merchants';
import PlanBlock from './plan-block';

const Payment = () => {
  const t = useTranslations();
  const [selectedPayment, setSelectedPayment] = useState<string | null>('payme');
  const { mutate, isLoading } = useBuyPremium();
  const [plan, setUser] = useState<number | null>(null);
  const [alreadyPaid, setAlreadyPaid] = useState(false);

  const onBuyPremium = () => {
    mutate(
      { type: selectedPayment, month_count: plan as number, platform: getPlatform() },
      {
        onSuccess: data => {
          if (data === true) {
            setAlreadyPaid(true);
          }
        }
      }
    );
  };

  useEffect(() => {
    const plan = getFromLocalStorage('plan');

    if (plan) setUser(Number(plan));
  }, []);

  return (
    <div className="mt-43.5 max-w-109.5 mx-auto">
      <div className="mb-4 flex items-center justify-center gap-1 space-x-2 text-lg font-medium">
        <GradientStarIcon />
        <span className="from-green-450 to-blue-450 inline-block bg-gradient-to-br bg-clip-text text-3xl font-bold text-transparent">
          Akam Pro
        </span>
      </div>

      {alreadyPaid ? (
        <div className="mb-4 w-full rounded-2xl bg-gray-800 p-3.5 text-center text-red-500">
          {t('bu_tarif_allaqachon_sotib_olingan')}
        </div>
      ) : null}

      <Merchants selectedPayment={selectedPayment} setSelectedPayment={setSelectedPayment} />

      <PlanBlock plan={plan} />

      <div className="mt-6.5">
        <Button
          loading={isLoading}
          type="primary"
          onClick={onBuyPremium}
          disabled={!selectedPayment}
          className="!h-12 !w-full !rounded-lg !border-transparent !bg-green-500 !py-5 !text-lg !font-medium !text-white disabled:!bg-gray-300/60 disabled:!text-black/50"
        >
          {t('obuna_bolish')}
        </Button>
      </div>
    </div>
  );
};

export default Payment;
